var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"moveEl",class:{transition:_vm.isTransition},style:(`right: ${_vm.right}px; bottom:${_vm.bottom}px;`),on:{"touchmove":function($event){$event.preventDefault();return _vm.touchmove.apply(null, arguments)},"touchstart":_vm.touchstart,"touchend":_vm.touchend}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }